<script>
import LanguageMappingsService from "../services/langmappings-service";
import GeoMappingsService from "../services/geomappings-service";
export default {
    methods: {
        labelizeData(data, breakdown) {
            switch (breakdown) {
                case "language": {
                    if (data.length == 2)
                    {
                        return LanguageMappingsService.alpha2(data);
                    } else if (data.length == 3) {
                        return LanguageMappingsService.alpha3(data);
                    }
                    
                }
                case "nationality": {
                    if (data.length == 2) {
                        return GeoMappingsService.alpha2(data);
                    } else if (data.length == 3) {
                        return GeoMappingsService.alpha3(data);
                    }
                    
                }
            }
            return this.labelizeGeneral(data);
        },
    }
}
</script>